import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const EditIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <g fill="none" stroke={props.nativeColor}>
                <line x1="5" y1="18.8" x2="19" y2="18.8"/>
                <line x1="11.8" y1="6.7" x2="14.3" y2="9.2"/>
                <path d="M7.5,16h-2C5.2,16,5,15.8,5,15.5v-2l8.1-8.1c0.2-0.2,0.5-0.2,0.7,0l1.8,1.8c0.2,0.2,0.2,0.5,0,0.7L7.5,16z"/>
            </g>
        </SvgRoot>
    );
}

export default EditIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/EditIcon.tsx